import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const InsightArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="Artboard" transform="translate(-623.000000, -46.000000)">
          <g id="Insight_article" transform="translate(623.000000, 46.000000)">
            <path
              d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
              fill="#008CC7"
              id="Fill-1"
            ></path>
            <path
              d="M20.1674,13.8655 C20.1674,10.9335 17.6214,8.5965 14.6204,8.9435 C12.4314,9.1955 10.6344,10.9255 10.3104,13.1045 C9.9624,15.4475 11.2544,17.5365 13.2104,18.4005 L13.2104,22.0435 C13.2104,22.4815 13.5654,22.8365 14.0024,22.8365 L14.0024,22.8365 L14.0024,23.3925 C14.0024,23.9085 14.4214,24.3275 14.9374,24.3275 L15.8424,24.3275 C16.3584,24.3275 16.7764,23.9085 16.7764,23.3925 L16.7764,22.8365 C17.1414,22.8365 17.4374,22.5405 17.4374,22.1755 L17.4374,18.2935 C19.0564,17.4775 20.1674,15.8015 20.1674,13.8655"
              fill="#ffffff"
              className={styles.white}
              id="Fill-3"
            ></path>
            <path
              d="M11.5007,13.8655 C11.5007,11.7465 13.2187,10.0285 15.3377,10.0285"
              id="Stroke-5"
              stroke="9ad7f2"
              strokeLinecap="round"
              strokeWidth="0.5"
            ></path>
            <g id="Group-10" transform="translate(14.823800, 5.505000)">
              <line
                fill="#e5e5e5"
                id="Fill-7"
                x1="0.5"
                x2="0.5"
                y1="3.55271368e-15"
                y2="1.849"
              ></line>
              <line
                id="Stroke-9"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="0.5"
                x2="0.5"
                y1="3.55271368e-15"
                y2="1.849"
              ></line>
            </g>
            <g id="Group-14" transform="translate(10.859600, 6.910900)">
              <line fill="#e5e5e5" id="Fill-11" x1="0.01" x2="0.99" y1="0" y2="1.522"></line>
              <line
                id="Stroke-13"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="0.01"
                x2="0.99"
                y1="0"
                y2="1.522"
              ></line>
            </g>
            <g id="Group-18" transform="translate(7.975000, 9.654600)">
              <line
                fill="#e5e5e5"
                id="Fill-15"
                x1="-8.8817842e-16"
                x2="1.548"
                y1="0.072"
                y2="0.928"
              ></line>
              <line
                id="Stroke-17"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="-8.8817842e-16"
                x2="1.548"
                y1="0.072"
                y2="0.928"
              ></line>
            </g>
            <g id="Group-22" transform="translate(6.937800, 13.365500)">
              <line
                fill="#e5e5e5"
                id="Fill-19"
                x1="-8.8817842e-16"
                x2="1.68"
                y1="0.5"
                y2="0.5"
              ></line>
              <line
                id="Stroke-21"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="-8.8817842e-16"
                x2="1.68"
                y1="0.5"
                y2="0.5"
              ></line>
            </g>
            <g id="Group-26" transform="translate(18.634000, 6.967600)">
              <line fill="#e5e5e5" id="Fill-23" x1="0.11" x2="0.89" y1="1.409" y2="0"></line>
              <line
                id="Stroke-25"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="0.11"
                x2="0.89"
                y1="1.409"
                y2="0"
              ></line>
            </g>
            <g id="Group-30" transform="translate(20.884100, 9.528000)">
              <line fill="#e5e5e5" id="Fill-27" x1="0" x2="1.485" y1="0.928" y2="0.072"></line>
              <line
                id="Stroke-29"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="0"
                x2="1.485"
                y1="0.928"
                y2="0.072"
              ></line>
            </g>
            <g id="Group-34" transform="translate(21.824900, 13.365500)">
              <line fill="#e5e5e5" id="Fill-31" x1="0" x2="1.799" y1="0.5" y2="0.5"></line>
              <line
                id="Stroke-33"
                stroke="#FFFFFF"
                className={styles.whiteStroke}
                strokeLinecap="round"
                strokeWidth="0.5"
                x1="0"
                x2="1.799"
                y1="0.5"
                y2="0.5"
              ></line>
            </g>
            <line
              id="Stroke-35"
              stroke="#9ad7f2"
              strokeLinecap="round"
              strokeWidth="0.5"
              x1="12.943"
              x2="17.671"
              y1="20.2099"
              y2="20.2099"
            ></line>
            <line
              id="Stroke-37"
              stroke="#9ad7f2"
              strokeLinecap="round"
              strokeWidth="0.5"
              x1="12.943"
              x2="17.671"
              y1="21.3753"
              y2="21.3753"
            ></line>
          </g>
        </g>
      </g>
    </Icon>
  )
}
